<template>
    <announcing-tooltip
        :text="`${prefix} - ${tooltipText}`"
        :prefix="prefix"
    >
        <i 
            :class="['fa-regular', 'fa-circle-question', 'not-set-icon', sizeClass]"
            aria-hidden="true">
        </i>
    </announcing-tooltip>
</template>

<script>
import announcingTooltip from './announcingTooltip.vue';

export default {
    name: 'not-set-icon',
    components: {
        'announcing-tooltip': announcingTooltip
    },
    props: {
        tooltipText: {
            type: String,
            default: 'Not set by District'
        },
        prefix: {
            type: String,
            default: 'Status'
        },
        size: {
            type: String,
            default: 'medium',
            validator: value => ['small', 'medium', 'large'].includes(value)
        }
    },
    computed: {
        sizeClass() {
            return `not-set-${this.size}`;
        }
    }
}
</script>

<style scoped>
.not-set-icon {
    color: #6c757d;
}

.not-set-small {
    font-size: 14px;
}

.not-set-medium {
    font-size: 16px;
}

.not-set-large {
    font-size: 24px;
}
</style>